export default "__VITE_ASSET__BhSsm$59__"